// extracted by mini-css-extract-plugin
export default {"title":"fba-z","warning":"gba-z","sizeOptionsLegendText":"hba-z"};